import { useLocation } from 'react-router-dom';
import { Lock, MailQuestion } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { fmt } from '@/lib/format';

interface SuspendedLocationState {
  tenantId?: string;
  expiredAt?: string;
  requestId?: string;
}

export function SuspendedPage() {
  const location = useLocation();
  const state = (location.state as SuspendedLocationState | null) ?? {};

  return (
    <div className="flex min-h-[70vh] items-center justify-center px-4">
      <div className="w-full max-w-md space-y-6 text-center">
        <div className="mx-auto grid h-12 w-12 place-items-center rounded-xl bg-muted text-muted-foreground">
          <Lock className="h-5 w-5" />
        </div>

        <div className="space-y-2">
          <h1 className="text-[22px] font-semibold tracking-tight text-foreground">
            Subscription not active
          </h1>
          <p className="text-sm text-muted-foreground">
            This tenant's subscription has expired or is past due. Operational endpoints are
            paused until renewal.
          </p>
        </div>

        {(state.expiredAt || state.tenantId) && (
          <div className="rounded-lg border bg-card px-4 py-3 text-left text-[12px]">
            {state.expiredAt && (
              <div className="flex items-baseline justify-between gap-3">
                <span className="text-muted-foreground">Expired</span>
                <span className="font-medium text-foreground">{fmt.date(state.expiredAt)}</span>
              </div>
            )}
            {state.tenantId && (
              <div className="mt-1 flex items-baseline justify-between gap-3">
                <span className="text-muted-foreground">Tenant</span>
                <span className="font-mono text-foreground">{state.tenantId}</span>
              </div>
            )}
            {state.requestId && (
              <div className="mt-1 flex items-baseline justify-between gap-3">
                <span className="text-muted-foreground">Request id</span>
                <span className="font-mono text-[11px] text-muted-foreground">{state.requestId}</span>
              </div>
            )}
          </div>
        )}

        <div className="flex flex-col gap-2">
          <Button asChild>
            <a href="mailto:support@zafroi.com?subject=Subscription%20renewal">
              <MailQuestion className="h-4 w-4" />
              Contact ZAFROI ops
            </a>
          </Button>
          <Button asChild variant="ghost" size="sm">
            <a href="/dashboard">Back to dashboard</a>
          </Button>
        </div>

        <p className="text-[11px] text-muted-foreground">
          Platform administration remains accessible. Operators may continue managing tenants and
          API keys.
        </p>
      </div>
    </div>
  );
}
